import React, { useEffect, useState } from 'react';
import { sprintf } from 'sprintf-js';
import { gutterWidth, maxWidth } from 'theme';

import { fetchGroup } from 'api/groups';
import { fetchOrg } from 'api/orgs';
// import { Animation } from 'components/Animation';
import Box from 'components/Box';
import Link from 'components/Link';
import SearchContextHeader from 'components/SearchContextHeader';
import { Body } from 'components/Text';
import { SearchContext } from 'containers/SearchContextHeaderContainer';
import Layout from 'layouts/Layout';
import { LISTING_TYPE_HUMAN_NAME_MAP } from 'utils/constants';
import { setDocumentTitle } from 'utils/meta';

// @TODO: Implement this with correct design
// import * as ListingUnpublishedAnimation from '../../static/images/animations/listingunpublished/data.json';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ListingUnpublishedPage = ({
  groupId,
  orgId,
  url,
  searchContext,
  listingType,
  adminType,
}: {
  groupId?: string;
  orgId?: string;
  url?: Record<UserLocale, string>;
  searchContext?: SearchContext | null | undefined;
  listingType: string;
  adminType?: string;
}) => {
  const [showAdminUrl, setShowAdminUrl] = useState(false);
  useEffect(() => {
    /* TRANSLATORS: 404 page title */
    setDocumentTitle(getText('Page Not Found'));
  }, []);
  useEffect(() => {
    if (orgId) {
      fetchOrg(orgId)
        .then(() => setShowAdminUrl(true))
        .catch(() => setShowAdminUrl(false));
    }

    if (groupId) {
      fetchGroup(groupId)
        .then(() => setShowAdminUrl(true))
        .catch(() => setShowAdminUrl(false));
    }
  }, [groupId, orgId]);
  return (
    <Layout>
      <Box
        mx="auto"
        maxWidth={[480, null, maxWidth[3]]}
        p={[gutterWidth / 2, null, null, gutterWidth]}
      >
        <Box display={['block', null, 'flex']} alignItems="center">
          {/* <Box width={400} height={300}> */}
          {/*   <Animation */}
          {/*     animationData={ListingUnpublishedAnimation.default} */}
          {/*     assetsPath="/static/images/animations/listingunpublished/images/" */}
          {/*   /> */}
          {/* </Box> */}
          <Box textAlign="center" width={1} pr={[0, null, gutterWidth]}>
            {searchContext && (
              <SearchContextHeader
                mb={[4, 4, 4, '40px']}
                divider
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...searchContext}
              />
            )}
            <Body>
              {sprintf(
                /* TRANSLATORS: 404 page copy */
                getText(
                  'Whoops! This %(listingType)s listing was unpublished while you were browsing.'
                ),
                {
                  listingType: LISTING_TYPE_HUMAN_NAME_MAP[listingType],
                }
              )}
            </Body>
            {adminType && url && url[USER_LOCALE] && showAdminUrl ? (
              <Box display="flex" justifyContent="center" alignItems="center">
                <Link href={url[USER_LOCALE]} data-qa-id="view-profile-link">
                  {adminType === 'GROUP' &&
                    getText("View this group's profile")}
                  {adminType === 'ORG' &&
                    getText("View this organization's profile")}
                </Link>
              </Box>
            ) : null}
          </Box>
        </Box>
      </Box>
    </Layout>
  );
};

export default ListingUnpublishedPage;
